export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14090.598fdd02.jpg";